import React, { FC, ReactNode } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";

export interface PublicRouteProps extends RouteProps {
  authenticated: boolean;
}

export const PublicRoute: FC<PublicRouteProps> = ({
  component: Component,
  authenticated,
  ...rest
}) => {
  if (!Component) return null;
  return (
    <Route
      {...rest}
      render={(props): ReactNode =>
        authenticated === false ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default PublicRoute;
